import { useEffect } from 'react'
import { appSettings } from '@/shared/consts/appSettings'
import {
  hasWebViewCookiesPermitted,
  isWebView
} from '@/utils/helpers/webViewHelper'

function injectScript(
  src: string,
  options: { async?: boolean; defer?: boolean; id?: string } = {}
) {
  const existing = document.querySelector(`script[src="${src}"]`)
  if (existing) return
  const script = document.createElement('script')
  script.src = src
  if (options.async) script.async = true
  if (options.defer) script.defer = true
  if (options.id) script.id = options.id
  document.body.appendChild(script)
}

export const InjectScripts = () => {
  useEffect(() => {
    if (isWebView()) return

    if (hasWebViewCookiesPermitted() || !isWebView()) {
      injectScript(`${appSettings.publicUrl}/gtm.js`, { async: true })
    }

    if (!isWebView()) {
      injectScript(`${appSettings.publicUrl}/cookie-consent-extend.js`, {
        async: true,
        id: 'privacytoolsScript_hack'
      })
      injectScript(
        'https://cdn.privacytools.com.br/public_api/banner/script/bottom/5ZdG1241.js?t=1',
        { async: true, id: 'privacytoolsScript', defer: true }
      )
      injectScript(
        `https://www.google.com/recaptcha/api.js?render=${appSettings.recaptchaToken}`,
        { async: true, id: 'recaptchaScript', defer: true }
      )
    }
  }, [])

  return null
}
